import { Box, Button } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useDialogState } from '~/hooks/useDialogState';
import {
  EmployeeProposalsDialog,
  EmployeeProposalsTabs,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog';
import { EmployeeRewardingProposalDialogTabs } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/data';

type PropsType = {
  enabledProposalDialogTabs: EmployeeRewardingProposalDialogTabs[];
};

export const BillableHoursTab = (props: PropsType) => {
  const { enabledProposalDialogTabs } = props;
  const { t } = useTranslation();
  const { isOpen, open, close } = useDialogState();
  return (
    <Box>
      TBA tab content: BillableHoursTab
      <Button onClick={open}>{t('editBillableHoursProposal')}</Button>
      <EmployeeProposalsDialog
        open={isOpen}
        onClose={close}
        openOnTab={EmployeeProposalsTabs.BillableHoursProposal}
        enabledDialogTabs={enabledProposalDialogTabs}
      />
    </Box>
  );
};
